<template>
	<div>
		<div class="queryBox">
			<div class="mb10">
			</div>
			<div class="mb10">
				<span>话商：</span>
				<el-select v-model="billMerchantId" placeholder="请选择" size="mini" class="mr20" clearable>
					<el-option v-for="item in billMerchantList" :key="item.id" :label="item.username" :value="item.id"></el-option>
				</el-select>
				
				<span>状态：</span>
				<el-select v-model="billState" placeholder="请选择" size="mini" class="mr20" clearable>
					<el-option v-for="(item,index) in billStateArr" :key="index" :label="item" :value="index"></el-option>
				</el-select>
				
							
				<el-input size="mini" placeholder="请输入话商订单号" v-model="order_id" clearable class="mr20" style="width: 200px"></el-input>
				<el-input size="mini" placeholder="请输入代收订单号" v-model="order_water_no" clearable class="mr20" style="width: 200px"></el-input>
				<el-input size="mini" placeholder="充值号码" v-model="account" clearable class="mr20" style="width: 200px"></el-input>
				
			</div>
			
			<div class="mb10">
				
				<el-button size="mini" plain class="mr20" @click="setDate(-1)" :disabled="disLoading">前一天</el-button>
				<el-date-picker size="mini" v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
				 end-placeholder="结束日期" class="mr20"></el-date-picker>
				<el-button size="mini" plain class="mr20" @click="setDate(1)" :disabled="disLoading">后一天</el-button>
				
				<el-button size="mini" type="primary" :icon="disLoading?'el-icon-loading':'el-icon-search'" @click="getData" :disabled="disLoading">查询</el-button>
				<el-button size="mini" type="primary" icon="el-icon-document" @click="getExcel" :disabled="tableData.length == 0">导出</el-button>
			</div>
		</div>
		<template>
			<el-table :max-height="height" :data="tableData"  stripe v-loading="loading" :show-overflow-tooltip="true">
				<!-- <el-table-column type="index" label="序号"></el-table-column> -->
				<el-table-column fixed prop="order_id" label="订单号" width="160px">
					<template slot-scope="scope">
						<div v-if="scope.row.id">
							<div class="flexX flexJustifyStart">				
								<span class="whiteEllipsisHover">话商:{{scope.row.order_id}}</span>
								<span v-if="scope.row.order_id"> <i style="color: #0039ff;" class="el-icon-document-copy" @click="handleCopy(scope.row.order_id)"></i></span>
							</div>
							<div class="flexX flexJustifyStart">				
								<span class="whiteEllipsisHover">平台:{{scope.row.water_no}}</span>
								<span v-if="scope.row.water_no"> <i style="color: #0039ff;" class="el-icon-document-copy" @click="handleCopy(scope.row.water_no)"></i></span>
							</div>
							<div class="flexX flexJustifyStart">				
								<span class="whiteEllipsisHover">代收:{{scope.row.order_water_no}}</span>
								<span v-if="scope.row.order_water_no"> <i style="color: #0039ff;" class="el-icon-document-copy" @click="handleCopy(scope.row.order_water_no)"></i></span>
							</div>
							<div class="flexX flexJustifyStart">				
								<span class="whiteEllipsisHover">官网:{{scope.row.official_order_id}}</span>
								<span v-if="scope.row.official_order_id"> <i style="color: #0039ff;" class="el-icon-document-copy" @click="handleCopy(scope.row.official_order_id)"></i></span>
							</div>
							
						</div>
						<div class="textCenter" v-if="!scope.row.id">
							<span v-if="scope.$index == tableData.length-2">单页合计</span>
							<span v-if="scope.$index == tableData.length-1">总计</span>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="water_no" label="平台交易号"  width="145px" >
					<template slot-scope="scope">
						<div class="textCenter" v-if="scope.row.id">
							{{scope.row.water_no}}
						</div>
					</template>
				</el-table-column> -->
				<el-table-column  label="话商"  >
					<template slot-scope="scope">
						<div v-if="scope.row.id">	
							<div >
								{{scope.row.pbm_merchant_username}}
							</div>						
							<div>
								{{scope.row.pbm_merchant_id}}
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="account" label="充值号码" min-width="130px" >
					<template slot-scope="scope">
						<div v-if="scope.row.id">
							{{scope.row.account}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="面值"  >
					<template slot-scope="scope">
						<div v-if="scope.$index == tableData.length-2">
						<span>{{scope.row.parvalue | tofixed}}</span>
						</div>
						<div v-else-if="scope.$index == tableData.length-1">
							<span>{{scope.row.parvalue | tofixed}}</span>
						</div>
						<p v-else>{{scope.row.parvalue | tofixed}}</p>
					</template>
				</el-table-column>
				<el-table-column label="类型" width="130px" prop="business_type" >
					<template slot-scope="scope">
						<div v-if="scope.row.id">
							<!-- {{scope.row.business_type}} -->
							<div class="flexX flexJustifyStart">				
								<span>类型:{{scope.row.business_type}}</span>
							</div>
							<div class="flexX flexJustifyStart">				
								<span>运营商:{{scope.row.type_name}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column label="通道" width="70px" prop="pay_name" >
					<template slot-scope="scope">
						<div class="textCenter" v-if="scope.row.id">
							{{scope.row.type_name}}
						</div>
					</template>
				</el-table-column> -->
				<el-table-column label="省份" prop="province" >
					<template slot-scope="scope">
						<div  v-if="scope.row.id">
							{{scope.row.province}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="话单状态" >
					<template slot-scope="scope">
						<div v-if="scope.row.id" :class="scope.row.state==6?'csuccess':scope.row.state==7?'cdanger':''">{{scope.row.state_name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="时间" min-width="160px">
					<template slot-scope="scope">
						<div v-if="scope.row.id">
							<div class="flexX flexJustifyStart">				
								<span>提交:{{scope.row.add_time}}</span>
							</div>
							<div class="flexX flexJustifyStart">				
								<span>完成:{{scope.row.action_time}}</span>
							</div>
							<div class="flexX flexJustifyStart">				
								<span>过期:{{scope.row.expire_time}}</span>
							</div>
						</div>

					</template>
				</el-table-column>
				<!-- <el-table-column label="完成时间" width="133px" >
					<template slot-scope="scope">
						<div class="textCenter" v-if="scope.row.id">
							{{scope.row.action_time}}
						</div>
					</template>
				</el-table-column> -->
				<!-- <el-table-column label="过期时间" width="100px" >
					<template slot-scope="scope">
						
						<div v-if="scope.row.expire_time">
							{{scope.row.expire_time.split(" ")[0]}}
							<br>
							{{scope.row.expire_time.split(" ")[1]}}
						</div>

					</template>
				</el-table-column> -->
				<el-table-column label="通知" width="70px" prop="isnotifyed" >
					<template slot-scope="scope">
						<div v-if="scope.row.id" :class="scope.row.isnotifyed==1?'csuccess':scope.row.notify_count>0?'cdanger':''">{{scope.row.isnotifyed==1?'成功':scope.row.notify_count>0?'失败':'未通知'}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="order_water_no" label="代收订单号"  width="145px" >
					<template slot-scope="scope">
						<div class="textCenter" v-if="scope.row.id">
							{{scope.row.order_water_no}}
						</div>
					</template>
				</el-table-column> -->
				<!-- <el-table-column prop="official_order_id" label="官网订单号"  width="145px" >
					<template slot-scope="scope">
						<div class="textCenter" v-if="scope.row.id">
							{{scope.row.official_order_id}}
						</div>
					</template>
				</el-table-column> -->
				<el-table-column label="链接"  prop="pay_url"   width="140px">
					<template slot-scope="scope">
						<!-- <el-tooltip v-if="scope.row.pay_url" class="item" effect="dark" :content="scope.row.pay_url" placement="top-start"> -->
						    <div class="flexX flexJustifyStart"  v-if="scope.row.pay_url">				
								<span class="whiteEllipsisHover">付款:{{scope.row.pay_url}}</span>
								<span> <i style="color: #0039ff;" class="el-icon-document-copy" @click="handleCopy(scope.row.pay_url)"></i></span>
							</div>
							<div class="flexX flexJustifyStart" v-if="scope.row.pay_url">				
								<span class="whiteEllipsisHover">凭证:{{scope.row.pay_callback_url}}</span>
								<span> <i style="color: #0039ff;" class="el-icon-document-copy" @click="handleCopy(scope.row.pay_callback_url)"></i></span>
							</div>
							<!-- <p>{{scope.row.pay_url.substr(1,8)+'...'}}</p>
						    </el-tooltip> -->
					</template>
				</el-table-column>
				<!-- <el-table-column label="凭证链接" width="70px" prop="pay_callback_url"  show-overflow-tooltip>
					<template slot-scope="scope">
					
						<el-tooltip v-if="scope.row.pay_callback_url" class="item" effect="dark" :content="scope.row.pay_callback_url" placement="top-start">
							  <p>{{scope.row.pay_callback_url.substr(1,8)+'...'}}</p>
							</el-tooltip>
					</template>
				</el-table-column> -->
				<!-- <el-table-column prop="pay_type_name" label="交易方式/账号"></el-table-column> -->
				<el-table-column fixed='right' label="操作" width= "140px">
					<template slot-scope="scope">
				
						
						<div v-if="scope.row.id">
							<div>{{scope.row.auditor}}</div>
							<div>
								<el-link type="primary" @click="noticeIn(scope.row,scope.$index)">发送回调</el-link>
							</div>
							<!-- <div v-if="scope.row.state == 2">
								<el-link v-if="scope.row.is_manual == 0" type="primary" @click="showDia(scope.row,scope.$index)">补单</el-link>
							</div> -->
						</div>
						<!-- <div v-if="scope.row.state == 1">
							<el-link v-if="scope.row.card && scope.row.is_cancel == 0" type="primary" @click="ordercancel(scope.row,scope.$index)">撤单</el-link>
						</div> -->
					</template>
				</el-table-column>
			</el-table>
		</template>

		<div class="flexX pageBox mt20">
			<el-pagination :hide-on-single-page="true" @size-change="handleSizeChange" @current-change="handleCurrentChange"
			 :current-page="page" :page-sizes="pageSizesArr" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
			 :total="total"></el-pagination>
		</div>
		<el-dialog center class="dialog" top="100px" title="" :visible.sync="dialogVisible" @close="close" width="70%"
		 :close-on-click-modal="false">
			<div class="formBox" v-loading="dialogloading">
				<div>
					<el-tabs type="border-card" @tab-click="getInfoData" v-model="activeName">
						<el-tab-pane label="搬砖工" name='info'>
							<div class="flexX flexAround flexTop">

								<div>
									<el-form label-position="right" label-width="80px">
										<el-form-item label="用户名:">{{infoTotalData.name}}</el-form-item>
										<el-form-item label="账号:">{{infoTotalData.username}}</el-form-item>
										<el-form-item label="Skype:">
											<!-- {{infoTotalData.skype}} -->
											<el-link type="primary" :href="`skype:${infoTotalData.skype}?chat`" οnclick="return skypeCheck();">{{infoTotalData.skype}}</el-link>
										</el-form-item>
										<el-form-item label="手机号:">{{infoTotalData.telephone}}</el-form-item>
										<el-form-item label="上级:">{{infoTotalData.all_parent_name}}</el-form-item>
									</el-form>
								</div>
								<div>
									<el-form label-position="right" label-width="80px">
										<el-form-item label="奖金:">{{infoTotalData.total_yj | tofixed}}</el-form-item>
										<el-form-item label="提成:">{{infoTotalData.total_tc | tofixed}}</el-form-item>
										<el-form-item label="今日奖金:">{{infoTotalData.today_yj | tofixed}}</el-form-item>
										<el-form-item label="今日提成:">{{infoTotalData.today_tc | tofixed}}</el-form-item>
										<el-form-item label="卡数量:">{{infoTotalData.card_count}}</el-form-item>
									</el-form>
								</div>
							</div>
						</el-tab-pane>
						<!-- <el-tab-pane label="卡列表" name='bankList'>
							<div class="mb20"><span class="mr20">用户名：{{infoTotalData.name}}</span><span>账号：{{infoTotalData.username}}</span></div>
							<el-table size="mini" :data="cardListData" border="" stripe max-height="500px">
								<el-table-column prop="card" label="卡号" width="145px" ></el-table-column>
								<el-table-column prop="bank" label="银行" ></el-table-column>
								<el-table-column prop="true_name" label="姓名" ></el-table-column>
								<el-table-column prop="telephone" label="电话" ></el-table-column>

								<el-table-column label="昨日结余" >
									<template slot-scope='scope'>
										<div>{{scope.row.yes_true_quota | tofixed}}</div>
									</template>
								</el-table-column>
								<el-table-column label="今日收款" >
									<template slot-scope='scope'>
										<div>{{scope.row.money_in | tofixed}}</div>
									</template>
								</el-table-column>
								<el-table-column label="今日出款" >
									<template slot-scope='scope'>
										<div>{{scope.row.money_out | tofixed}}</div>
									</template>
								</el-table-column>
								<el-table-column label="当前余额" >
									<template slot-scope='scope'>
										<div>{{scope.row.true_quota | tofixed}}</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="flexX  mt20">
								<el-pagination :hide-on-single-page="true" @size-change="diahandleSizeChange" @current-change="diahandleCurrentChange"
								 :current-page="diapage" :page-sizes="diapageSizesArr" :page-size="diapageSize" layout="total, sizes, prev, pager, next, jumper"
								 :total="diatotal"></el-pagination>
							</div>
						</el-tab-pane> -->
						<el-tab-pane label="卡进账订单" name='cardNote'>
							<div class="mb20"><span class="mr20">用户名：{{infoTotalData.name}}</span><span>账号：{{infoTotalData.username}}</span></div>
							<el-table size="mini" :data="cardNoteData" border="" stripe max-height="500px">
								<el-table-column prop="true_name" label="姓名" ></el-table-column>
								<el-table-column prop="card" label="卡号" ></el-table-column>
								<el-table-column prop="order_id" label="订单号" ></el-table-column>

								<el-table-column label="金额" >
									<template slot-scope='scope'>
										<div>{{scope.row.gold | tofixed}}</div>
									</template>
								</el-table-column>
								<el-table-column prop="action_time" label="时间" ></el-table-column>

							</el-table>
							<div class="flexX  mt20">
								<el-pagination :hide-on-single-page="true" @size-change="nodehandleSizeChange" @current-change="nodehandleCurrentChange"
								 :current-page="nodepage" :page-sizes="nodepageSizesArr" :page-size="nodepageSize" layout="total, sizes, prev, pager, next, jumper"
								 :total="nodetotal"></el-pagination>
							</div>
						</el-tab-pane>

						<el-tab-pane label="卡出账订单" name='cardNoteOut'>
							<el-table size="mini" :data="cardNoteOutData" border="" stripe max-height="500px">
								<el-table-column prop="true_name" label="姓名" ></el-table-column>
								<el-table-column prop="card" label="卡号" ></el-table-column>
								<el-table-column prop="order_id" label="订单号" ></el-table-column>
								<el-table-column label="金额" >
									<template slot-scope='scope'>
										<div>{{scope.row.gold | tofixed}}</div>
									</template>
								</el-table-column>
								<el-table-column prop="action_time" label="时间" ></el-table-column>
							</el-table>
							<div class="flexX  mt20">
								<el-pagination :hide-on-single-page="true" @size-change="outhandleSizeChange" @current-change="outhandleCurrentChange"
								 :current-page="outpage" :page-sizes="outpageSizesArr" :page-size="outpageSize" layout="total, sizes, prev, pager, next, jumper"
								 :total="outtotal"></el-pagination>
							</div>
						</el-tab-pane>

						<!-- 卡账单 -->
						<el-tab-pane label="卡账单" name='cardBill'>
							<div class="mb20">
								<span class="mr20">用户名：{{infoTotalData.name}}</span>
								<span class="mr20">账号：{{infoTotalData.username}}</span>
								<span class="mr20" v-if="cardBillData.length>0">姓名：{{cardBillData[0].name}}</span>
								<span class="mr20" v-if="cardBillData.length>0">卡号：{{cardBillData[0].card}}</span>
								<span>更新时间：{{bill_update_time}}</span>
							</div>
							<el-table size="mini" :data="cardBillData" border="" stripe max-height="500px">
								<el-table-column type="index" label="序号"  width="50px"></el-table-column>
								<el-table-column prop="trans_date" label="交易时间"  min-width="140px"></el-table-column>
								<el-table-column label="金额" >
									<template slot-scope='scope'>
										<div>{{scope.row.amount | tofixed}}</div>
									</template>
								</el-table-column>
								<el-table-column prop="transplace" label="收支摘要"  min-width="140px">
									<template slot-scope='scope'>
										<div :class="scope.row.type=='出账'?'cdanger':'csuccess'">{{scope.row.transplace}}</div>
									</template>
								</el-table-column>
								<el-table-column label="账户余额" >
									<template slot-scope='scope'>
										<div>{{scope.row.keep_amount | tofixed}}</div>
									</template>
								</el-table-column>								
								<el-table-column prop="pay_card" label="对方账户"  min-width="140px"></el-table-column>
								<el-table-column prop="pay_name" label="对方户名"  width="140px"></el-table-column>								
								<el-table-column prop="remark" label="备注"  width="140px"></el-table-column>								
								
							</el-table>
							<div class="flexX  mt20">
								<el-pagination :hide-on-single-page="true" @size-change="billhandleSizeChange" @current-change="billhandleCurrentChange"
								 :current-page="billpage" :page-sizes="billpageSizesArr" :page-size="billpageSize" layout="total, sizes, prev, pager, next, jumper"
								 :total="billtotal"></el-pagination>
							</div>
						</el-tab-pane>


					</el-tabs>
				</div>
				<div class="textCenter">
					<el-button type="primary" @click="close">关闭</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog width="800px" center top="150px" title="补单" :visible.sync="bddialogVisible" @close="bdclose"
		 :close-on-click-modal="false">
			<div class="formBoxbd" v-loading="bddialogloading">
				<div>
					<el-form label-position="right" label-width="100px">
						<el-form-item label="订单号">
							{{item.order_id}}
						</el-form-item>
						<el-form-item label="流水号">
							{{item.water_no}}
						</el-form-item>
						<el-form-item label="商户名称">
							{{item.business_name}}
						</el-form-item>
						<el-form-item label="金额">
							{{item.submit_gold | tofixed}}元
						</el-form-item>
						<el-form-item label="补单类型">
							<el-select v-model="replenState" placeholder="请选择" size="mini" class="mr20" clearable>
								<el-option v-for="(item,index) in replenishmentStateObj" :key="index" :label="item" :value="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="补单金额">
							<el-input v-model="amount" placeholder="请输入补单金额"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="textCenter">
					<el-button type="primary" @click="onSubmit">确定</el-button>
				</div>
			</div>
		</el-dialog>
		
		<!-- 回调详情 -->
		<el-dialog width="800px" center top="150px" title="回调详情" :visible.sync="cbdialog" @close="cbclose"
		 :close-on-click-modal="false">
			<div class="formBoxbd" v-loading="cbdialogloading">
				<div>
					<el-form label-position="right" label-width="130px">
						<el-form-item label="订单号:">
							{{callbackData.order_id}}
						</el-form-item>
						<el-form-item label="商家号:">
							{{callbackData.business_no}}
						</el-form-item>
						<el-form-item label="商家名称:">
							{{item.business_name}}
						</el-form-item>
						<el-form-item label="通知结果:">
							<span :class="item.isnotifyed==1?'csuccess':'cdanger'">{{item.isnotifyed == 1?'通知成功':'通知失败'}}</span>
							
						</el-form-item>
						<el-form-item label="通知地址:">
							{{callbackData.notify_url}}
						</el-form-item>
						<el-form-item label="通知参数:">
							<el-input type="textarea" v-model="callbackData.notify_param" readonly autosize></el-input>
						</el-form-item>
						<el-form-item label="商户响应(返回)内容:">
							<el-card v-if="callbackData.trader_response" class="box-card">
							  <div v-for="(val, i) in JSON.parse(callbackData.trader_response)" :key="i" class="text item">
								  <el-divider></el-divider>
							    {{val.time}} <br>
								<span class="ml40">{{val.responseData}}</span>
								
							    
							  </div>
							</el-card>
							
						</el-form-item>
						
					</el-form>
				</div>
				<div class="textCenter">
					<el-button type="primary" @click="cbclose">关闭</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import local from '@/util/local'
	import {
		isEmpty,
		isPositiveNumber,
		isMoney,
		isMobile,
		isIncludeHanzi
	} from '@/util/validate'
	import {
		Message
	} from 'element-ui'
	export default {
		data() {
			return {
				loading: false,
				disLoading: false,
				tableData: [],
				pageSizesArr: [20, 50, 100, 200],
				pageSize: 20,
				total: 0,
				page: 1,
				diapageSizesArr: [20, 50, 100, 200],
				diapageSize: 20,
				diatotal: 0,
				diapage: 1,
				nodepageSizesArr: [20, 50, 100, 200],
				nodepageSize: 20,
				nodetotal: 0,
				nodepage: 1,
				outpageSizesArr: [20, 50, 100, 200],
				outpageSize: 20,
				outtotal: 0,
				outpage: 1,
				billpageSizesArr: [20, 50, 100, 200],
				billpageSize: 20,
				billtotal: 0,
				billpage: 1,
				order_id: '',
				water_no: '',
				business_no: '',
				card_name: '',
				business_name: '',
				add_gold: '',
				req_ip: '',
				payerName: '',
				pay_type: '',
				state: '',
				paywayArr: [],
				stateArr: {},
				// stateMap:{},
				date: null,
				countAll: {
					total_money: 0,
					success_money: 0,
					total_count: 0,
					success_count: 0,
				},
				dialogVisible: false,
				dialogloading: false,
				item: {},
				infoTotalData: {}, //搬砖工
				cardListData: [], //银行卡列表
				cardNoteData: [], //银行卡记录  流水
				cardNoteOutData: [], //卡出账记录 
				cardBillData: [], //卡账单
				bill_update_time: '', //卡账单 最后更新时间
				activeName: 'info',
				//补单
				replenState: '',
				replenishmentStateObj: {}, //补单类型
				bddialogVisible: false, //补单弹框
				amount: '', //补单金额
				item: {}, //当前补单的数据
				index: {}, //当前item 索引
				// orderType:"",//订单操作类型  cancle 撤单
				bddialogloading: false,
				height: 0,
				paywayTypeList:[],//通道的筛选项
				payway_type_id:'',	
				// 回调详情
				cbdialog: false,
				callbackData: [],
				cbdialogloading: false,
				// 话单
				account: '',
				BillMerchantList: [],
				billMerchantId: '',
				billStateArr: [],
				billState: '',
				order_water_no: '',
				totalArr: [],
				
			};
		},
		created() {
			this.date = [this.$util.timestampToTime(new Date().getTime(), true), this.$util.timestampToTime(new Date().getTime(),true)];
			// this.paywayAll()
			this.getTotalMoney()
			this.billStateList()
			this.orderAllList()
			this.orderCountAll()
			this.replenishmentState()
			this.billMerchantList()
			this.$nextTick(() => {
				let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
				// let threeDirectoryBox = document.getElementsByClassName('threeDirectoryBox')[0].offsetHeight;
				let queryBox = document.getElementsByClassName('queryBox')[0].offsetHeight;
				let pageBox = document.getElementsByClassName('pageBox')[0].offsetHeight;
				let documentHeight = document.documentElement.clientHeight
				this.height = documentHeight - topNav - 20 - pageBox - 20 - queryBox - 20
			})
		},
		mounted(){
			let self = this
			document.onkeydown = function(e) {
			  let ev = document.all ? window.event : e
			  if (ev.keyCode === 13) {
				  if(!self.loading){
					  self.getData()
				  }
				
			  }
			}
		},
		destroyed() {
			document.onkeydown = null
		},
		filters: {
			tofixed: function(value) {
				if (value || value == 0) {
					// console.log('sssssssssss', (value * 1).toFixed(2) + '')
					// return ((value * 1).toFixed(2) + '').replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					// return ((Math.floor((value * 1)*100)/100).toFixed(2) + '').replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
					let val =Math.floor(((value * 1)*100).toPrecision(12))
					return ((val/100).toFixed(2) + '').replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
				}
			}
		},
		methods: {
			setHfRate(value){
				let submitData = {
					type: value.type,
					parvalue: value.parvalue,
					rate: value.rate,
				}
				this.$api.setPoolRate(submitData).then(res => {
					// console.log(res)
					if (res.status == 1) {
						this.$message({
							type: 'success',
							message: res.msg
						})
						this.getTotalMoney()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},
			setDate(day) {
				let data = this.date ? this.date[0] : this.$util.timestampToTime(new Date().getTime(), true)
				let newDate = this.$util.getLastDate(data, day);
				this.date = [newDate, newDate]
				this.getData()
			},
			getTimeDifference(startTime, endTime) {
				return this.$util.intervalTime(startTime, endTime)
			},
			//搜索按钮
			getData() {
				this.page = 1;
				this.orderAllList();
				this.getTotalMoney()
			},
			//总计
			orderCountAll() {
				this.$api.orderCountAll({}).then(res => {
					// console.log(res)
					if (res.status == 1) {
						this.countAll = res.data
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},
			//导出Excel
			getExcel() {
				// /manager/pbm_order/exportList
				// console.log(this.$baseURL)
				// let data = {
				let username = local.get('fourusername');
				let tid = local.get('fourtid')
				
				let order_id = this.order_id
				let account = this.account
				let order_water_no = this.order_water_no
				let pbm_merchant_id = this.billMerchantId
				let state = this.billState
				
				let start_time = this.date ? this.$util.timestampToTime(Date.parse(new Date(this.date[0])), true) : '';
				let end_time = this.date ? this.$util.timestampToTime(Date.parse(new Date(this.date[1])), true) : '';
				// }
				let href =
					`${this.$baseURL}/manager/pbm_order/exportList?username=${username}&tid=${tid}&order_id=${order_id}&account=${account}&order_water_no=${order_water_no}&pbm_merchant_id=${pbm_merchant_id}&state=${state}&start_time=${start_time}&end_time=${end_time}`
				// window.location.href = href
				window.open(href)
			},
			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.pageSize = val
				this.page = 1
				this.orderAllList()
			},
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.page = val
				this.orderAllList()
			},
			diahandleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.diapageSize = val
				this.diapage = 1
				this.cardList()
			},
			diahandleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.diapage = val
				this.cardList()
			},

			nodehandleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.nodepageSize = val
				this.nodepage = 1
				this.moneyList()
			},
			nodehandleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.nodepage = val
				this.moneyList()
			},
			outhandleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.outpageSize = val
				this.outpage = 1
				this.outList()
			},
			outhandleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.outpage = val
				this.outList()
			},
			billhandleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.billpageSize = val
				this.billpage = 1
				this.cardBill()
			},
			billhandleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.billpage = val
				this.cardBill()
			},

			paywayAll() {
				this.$api.paywayAll({hasRepay:2}).then(res => {
					if (res.status === 1) {
						this.paywayArr = res.data.data
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},

			getTotalMoney() {
				let data = {
					pbm_merchant_id: this.billMerchantId,
				}
				this.$api.getTotalMoney(data).then(res => {
					if (res.status === 1) {
						this.totalArr = res.data
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},
			orderAllList() {
				let data = {
					order_id: this.order_id,
					account: this.account,
					order_water_no: this.order_water_no,
					pbm_merchant_id: this.billMerchantId,
					state: this.billState,
					start_time: this.date ? this.$util.timestampToTime(Date.parse(new Date(this.date[0])), true) : '',
					end_time: this.date ? this.$util.timestampToTime(Date.parse(new Date(this.date[1])), true) : '',
					page: this.page,
					size: this.pageSize,
				}
				// this.loading = true
				this.disLoading = true
				// console.log('disLoading', this.disLoading)
				this.$api.billOrderList(data).then(res => {
					this.loading = false;
					this.disLoading = false;
					if (res.status === 1) {
						this.tableData = res.data.data;
						this.total = res.data.total
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}).catch(error => {
					this.loading = false
					this.disLoading = false
				})
			},
			showCallbackInfo(item) {
				// this.$router.push({path:'/orderInfo'})
				this.cbdialog = true;
				this.item = item
				this.infoCallBack(item)
			},
			showInfo(item) {
				// this.$router.push({path:'/orderInfo'})
				this.dialogVisible = true;
				this.item = item
				this.infoTotal(item)
			},
			getInfoData(val) {
				if (val.name == 'info') {
					if (JSON.stringify(this.infoTotalData) == '{}') {
						this.infoTotal()
					}
				}
				if (val.name == 'bankList') {
					if (this.cardListData.length == 0) {
						this.cardList()
					}
				}
				if (val.name == 'cardNote') {
					if (this.cardNoteData.length == 0) {
						this.moneyList()
					}
				}
				if (val.name == 'cardNoteOut') {
					if (this.cardNoteOutData.length == 0) {
						this.outList()
					}
				}
				if (val.name == 'cardBill') {
					if (this.cardBillData.length == 0) {
						this.cardBill()
					}
				}
				// console.log('val', val)
			},
			infoCallBack(item) {
				
				let data = {
					order_id: item.order_id,
					business_no: item.business_no,
				}
				this.cbdialogloading = true
				this.$api.checkNotifyLog(data).then(res => {
					this.cbdialogloading = false
					if (res.status == 1) {
						this.callbackData = res.data
					} else {
						this.$message({
							"type": "error",
							message: res.msg
						})
					}
				}).catch(error => {
					this.cbdialogloading = false
				})
			},
			infoTotal(item) {
				let data = {
					id: item.bank_card_id,
					type: 2
				}
				// this.dialogloading = true
				this.$api.infoTotal(data).then(res => {
					this.dialogloading = false
					if (res.status == 1) {
						this.infoTotalData = res.data
					} else {
						this.$message({
							"type": "error",
							message: res.msg
						})
					}
				}).catch(error => {
					this.dialogloading = false
				})
			},
			cardList(item) {
				let data = {
					carder_id: this.infoTotalData.id,
					size: this.diapageSize,
					page: this.diapage,
					// type:2
				}

				// this.dialogloading = true
				this.$api.cardList(data).then(res => {
					this.dialogloading = false
					if (res.status == 1) {
						this.cardListData = res.data.data
						this.diatotal = res.data.total

					} else {
						this.$message({
							"type": "error",
							message: res.msg
						})
					}
				}).catch(error => {
					this.dialogloading = false
				})
			},
			close() {
				this.dialogVisible = false
				this.item = {}
				this.infoTotalData = {} //搬砖工
				this.cardListData = [] //银行卡列表
				this.cardNoteData = [] //银行卡记录  流水
				this.cardNoteOutData = []
				this.cardBillData = []
				this.activeName = 'info'
				this.diapage = 1
				this.nodepage = 1
				this.outpage = 1
				this.billpage = 1

			},

			//补单按钮
			replenishmentState() {
				this.$api.replenishmentState({}).then(res => {
					if (res.status == 1) {
						this.replenishmentStateObj = res.data
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},
			//通知商家
			noticeIn(item, index) {
				this.$confirm("确定执行此操作吗？", "提示", {
					confirmButtonText: '提交',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data = {
						id: item.id
					}
					this.loading = true
					this.$api.billOrderNoitce(data).then(res => {
						this.loading = false;
						if (res.status == 1) {
							this.$message ({
								type: 'success',
								message: '执行成功'
							})
						} else {
							this.$message ({
								type: 'error',
								message: res.msg
							})
						}
					}).catch(error => {
						this.loading = false
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消发送回调'
					});
				});
			},

			showDia(item, index) {
				this.item = item
				this.index = index
				// this.orderType=type
				this.bddialogVisible = true
				if (JSON.stringify(this.replenishmentStateObj) == '{}') {
					this.replenishmentState()
				}
			},
			//确认补单
			onSubmit() {
				if (isEmpty(this.replenState, '请选择补单类型')) {
					return
				}
				// if (isEmpty(this.amount, '请选输入补单金额')) {
				// 	return
				// }
				// if (!isMoney(this.amount, '补单金额只能是数字，且最多保留两位小数')) {
				// 	return
				// }
				let data = {
					id: this.item.id,
					state: this.replenState,
					amount: this.amount
				}
				this.bddialogloading = true;
				this.$api.replenishment(data).then(res => {
					this.bddialogloading = false;
					if (res.status == 1) {
						this.orderAllList()
						this.bdclose();
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}).catch(() => {
					this.bddialogloading = false;
				})
			},
			bdclose() {
				this.item = {}
				this.bddialogVisible = false
				this.replenState = ''
				this.amount = ''
			},
			cbclose() {
				this.item = {}
				this.cbdialog = false
				this.callbackData = []
			},
			moneyList() {
				let data = {
					page: this.nodepage,
					size: this.nodepageSize,
					id: this.item.bank_card_id,
				}
				// this.dialogloading = true
				this.$api.moneyList(data).then(res => {
					this.dialogloading = false
					if (res.status == 1) {
						this.cardNoteData = res.data.data
						this.nodetotal = res.data.total
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}).catch(error => {
					this.dialogloading = false
				})
			},
			outList() {
				let data = {
					page: this.outpage,
					size: this.outpageSize,
					id: this.item.bank_card_id,
				}
				// this.dialogloading = true
				this.$api.outList(data).then(res => {
					this.dialogloading = false
					if (res.status == 1) {
						this.cardNoteOutData = res.data.data
						this.outtotal = res.data.total
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}).catch(error => {
					this.dialogloading = false
				})
			},
			//卡账单
			cardBill() {
				let data = {
					page: this.billpage,
					size: this.billpageSize,
					id: this.item.bank_card_id,
				}
				// this.dialogloading = true
				this.$api.cardBill(data).then(res => {
					this.dialogloading = false
					if (res.status == 1) {
						this.cardBillData = res.data.data
						this.billtotal = res.data.total
						this.bill_update_time = res.data.bill_update_time
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				}).catch(error => {
					this.dialogloading = false
				})
			},
			//撤单
			ordercancel(item, index) {
				this.$confirm("确定执行此操作吗？", "提示", {
					confirmButtonText: '提交',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data = {
						id: item.id
					}
					this.loading = true
					this.$api.ordercancel(data).then(res => {
						this.loading = false
						if (res.status == 1) {
							this.orderAllList()
							this.$message({
								type: 'success',
								message: '执行成功'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					}).catch(error => {
						this.loading = false
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消撤单'
					});
				});
			},
			//通道的筛选项
			billMerchantList(){
				this.$api.billMerchantList({}).then(res=>{
					this.billMerchantList = res.data
				})
			},
			// 话单状态选项
			billStateList() {
				this.$api.billStateList({}).then(res => {
					if (res.status === 1) {
						this.billStateArr = res.data
						// this.stateArr.forEach(item=>{
						// 	this.stateMap[item.id] = item.note
						// })
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},
			handleCopy(textCopy){
				
				const contentToCopy = textCopy
				// 创建一个临时的 textAREA 元素
				const textarea = document.createElement('textarea')
				textarea.value = contentToCopy
				document.body.appendChild(textarea)
				textarea.select()
				document.execCommand('copy')
				document.body.removeChild(textarea)
				this.$message({
					type: 'success',
					message: '已复制到剪切板'
				})
			},

		},
		watch: {
			total(val, old) {
				this.$nextTick(() => {
					let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
					// let threeDirectoryBox = document.getElementsByClassName('threeDirectoryBox')[0].offsetHeight;
					let queryBox = document.getElementsByClassName('queryBox')[0].offsetHeight;
					let pageBox = document.getElementsByClassName('pageBox')[0].offsetHeight;
					let documentHeight = document.documentElement.clientHeight
					this.height = documentHeight - topNav - 20 - pageBox - 20 - queryBox - 20
				})
			}
		},
	};
</script>

<style lang="scss" scoped="scoped">
	@import '@/style/variables.scss';
	.formBoxbd {
		width: 80%;
		margin: 0 auto;
	}
	
	.cardBox {
		.text {
			font-size: 14px;
		}
	
		.clearfix:before,
		.clearfix:after {
			display: table;
			content: "";
			height: 1px;
			width: 100%;
		}
	
		.clearfix:after {
			clear: both
		}
	
		.box-card {
			width: 11.75rem;
			box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.5);
	
			.cardHeader {
				padding: 5px 5px;
				color: $baseColor;
			}
	
			.cardCon {
				padding: 5px;
				background: rgba(0, 0, 0, 0.2);
				color: $baseColor;
			}
	
			&.shou {
				background: $success;
			}
	
			&.fu {
				background: $warning;
			}
	
			&.run {
				background: $info;
			}
	
			&.ka {
				background: $warning;
			}
	
			&.success {
				background: $primary;
			}
	
			&.keshou {
				background: $success;
			}
	
			&.yue {
				background: $primary;
			}
		}
	}
</style>
